// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/DownCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleOutlinedSvg
  }));
};

DownCircleOutlined.displayName = 'DownCircleOutlined';
export default React.forwardRef(DownCircleOutlined);